/* /bat-comparator-json is proxied to either chrome data or jato. See LSDS */
define('lib/services/compare-service-jato',['lib/rest'], function (RestAPI) {
  var spec = {
    host: '/bat-comparator-json-jato',
    apis: {
      report: {
        url: '/comparisonReport',
        calls: {
          fetch: {
            url: '',
            dataType: 'json',
            defaults: {
              clientId: 'Toyota',
              langCode: 1, // English
              vehicles: null // JatodIDs. Lead with TOY trim
            }
          }
        }
      }


    }
  };

  return new RestAPI(spec);
});

